function About() {
  return (
    <div className="about">
      <h4>
        Используется бесплатный JSON API:
        <p>
          <a href=" https://themealdb.com/api.php" target="_blank">
            TheMealDB
          </a>
        </p>
      </h4>
      <p>
        Добро пожаловать в TheMealDB: открытую краудсорсинговую базу данных
        рецептов со всего мира.
      </p>
    </div>
  );
}

export default About;
